module.exports = {
    catalogUrl: 'https://stac.geoplatform.gov/catalog.json',
    catalogTitle: "GeoPlatform STAC",
    catalogImage: null,
    allowExternalAccess: true, // Must be true if catalogUrl is not given
    allowedDomains: [],
    detectLocaleFromBrowser: true,
    storeLocale: true,
    locale: "en",
    fallbackLocale: "en",
    supportedLocales: [
        "de",
        "ar",
//      "de-CH",
        "es",
        "en",
        "fr",
//      "fr-CA",
//      "fr-CH",
        "it",
//      "it-CH",
        "ro",
        "ja",
        "pt",
        "id",
        "pl"
    ],
    apiCatalogPriority: null,
    useTileLayerAsFallback: false,
    displayGeoTiffByDefault: false,
    displayPreview: true,
    displayOverview: true,
    buildTileUrlTemplate: null,
    getMapSourceOptions: null,
    pathPrefix: "/",
    historyMode: "hash",
    cardViewMode: "cards",
    cardViewSort: "asc",
    showThumbnailsAsAssets: false,
    showKeywordsInItemCards: true,
    showKeywordsInCatalogCards: true,
    itemsPerPage: 12,
    searchResultsPerPage: null,
    collectionsPerPage: null,
    maxEntriesPerPage: 1000,
    defaultThumbnailSize: null,
    crossOriginMedia: null,
    requestHeaders: {},
    requestQueryParameters: {},
    socialSharing: ['email', 'bsky', 'mastodon', 'x'],
    crs: {},
    footerLinks: null,
    authConfig: null,
    preprocessSTAC: (() => {
        const stacMetadata = {
            '/external/stac.asf.alaska.edu/': {
                title: 'Alaska Satellite Facility',
                description: 'The Alaska Satellite Facility is part of the Geophysical Institute of the University of Alaska Fairbanks, located on the Troth Yeddha’ campus.'
            },
            '/external/landsatlook.usgs.gov/stac-server/': {
                title: 'DOI | USGS | Landsat Catalog',
                description: 'The LandsatLook STAC Server API provides programmatic search, exploration and download of USGS Landsat Collection 2 data, including Cloud Optimized GeoTIFFs (COGs) with STAC metadata. See https://www.usgs.gov/landsat-missions/spatiotemporal-asset-catalog-stac'
            },
            '/external/api.waterdata.usgs.gov/ogcapi/v0/': { title: 'USGS Water Data' },
            '/external/hub.arcgis.com/api/search/v1/collections/all': { title: 'Esri ArcGIS Hub' },
            '/external/data-algeohub.opendata.arcgis.com/api/search/v1/collections/all': { title: 'Alabama' },
            '/external/akgeoportal.alaska.gov/api/search/v1/collections/all': { title: 'Alaska' },
            '/external/azgeo-data-hub-agic.hub.arcgis.com/api/search/v1/collections/all': { title: 'Arizona' },
            '/external/gis.data.ca.gov/api/search/v1/collections/all': { title: 'California' },
            '/external/ct-deep-gis-open-data-website-ctdeep.hub.arcgis.com/api/search/v1/collections/all': { title: 'Connecticut' },
            '/external/geodata.floridagio.gov/api/search/v1/collections/all': { title: 'Florida' },
            '/external/data-hub.gio.georgia.gov/api/search/v1/collections/all': { title: 'Georgia' },
            '/external/geoportal.hawaii.gov/api/search/v1/collections/all': { title: 'Hawaii' },
            '/external/gis-idaho.hub.arcgis.com/api/search/v1/collections/all': { title: 'Idaho' },
            '/external/www.indianamap.org/api/search/v1/collections/all': { title: 'Indiana' },
            '/external/data.imap.maryland.gov/api/search/v1/collections/all': { title: 'Maryland' },
            '/external/gis-michigan.opendata.arcgis.com/api/search/v1/collections/all': { title: 'Michigan' },
            '/external/opendata.gis.ms.gov/api/search/v1/collections/all': { title: 'Mississippi' },
            '/external/data-msdis.opendata.arcgis.com/api/search/v1/collections/all': { title: 'Missouri' },
            '/external/map-nebraska.hub.arcgis.com/api/search/v1/collections/all': { title: 'Nebraska' },
            '/external/www.nhgeodata.unh.edu/api/search/v1/collections/all': { title: 'New Hampshire' },
            '/external/data-nmenv.opendata.arcgis.com/api/search/v1/collections/all': { title: 'New Mexico' },
            '/external/data.gis.ny.gov/api/search/v1/collections/all': { title: 'New York' },
            '/external/www.nconemap.gov/api/search/v1/collections/all': { title: 'North Carolina' },
            '/external/gishubdata-ndgov.hub.arcgis.com/api/search/v1/collections/all': { title: 'North Dakota' },
            '/external/csagis-uok.opendata.arcgis.com/api/search/v1/collections/all': { title: 'Oklahoma' },
            '/external/geohub.oregon.gov/api/search/v1/collections/all': { title: 'Oregon' },
            '/external/www.rigis.org/api/search/v1/collections/all': { title: 'Rhode Island' },
            '/external/data-scdnr.opendata.arcgis.com/api/search/v1/collections/all': { title: 'South Carolina' },
            '/external/tn-tnmap.opendata.arcgis.com/api/search/v1/collections/all': { title: 'Tennessee' },
            '/external/geodata.vermont.gov/api/search/v1/collections/all': { title: 'Vermont' },
            '/external/geo.wa.gov/api/search/v1/collections/all': { title: 'Washington' },
            '/external/data-wi-dnr.opendata.arcgis.com/api/search/v1/collections/all': { title: 'Wisconsin' },
            '/external/data.geospatialhub.org/api/search/v1/collections/all': { title: 'Wyoming' },
            '/external/ngda-address-geoplatform.hub.arcgis.com/api/search/v1/collections/all': { title: 'Address' },
            '/external/ngda-biodiversity-geoplatform.hub.arcgis.com/api/search/v1/collections/all': { title: 'Biodiversity and Ecosystems' },
            '/external/ngda-cadastre-geoplatform.hub.arcgis.com/api/search/v1/collections/all': { title: 'Cadastre' },
            '/external/ngda-climate-and-weather-geoplatform.hub.arcgis.com/api/search/v1/collections/all': { title: 'Climate and Weather' },
            '/external/ngda-cultural-resources-geoplatform.hub.arcgis.com/api/search/v1/collections/all': { title: 'Cultural Resources' },
            '/external/ngda-elevation-geoplatform.hub.arcgis.com/api/search/v1/collections/all': { title: 'Elevation' },
            '/external/ngda-geodetic-control-geoplatform.hub.arcgis.com/api/search/v1/collections/all': { title: 'Geodetic Control' },
            '/external/ngda-geology-geoplatform.hub.arcgis.com/api/search/v1/collections/all': { title: 'Geology' },
            '/external/ngda-gov-units-geoplatform.hub.arcgis.com/api/search/v1/collections/all': { title: 'Governmental Units, and Administrative and Statistical Boundaries' },
            '/external/ngda-imagery-theme-geoplatform.hub.arcgis.com/api/search/v1/collections/all': { title: 'Imagery' },
            '/external/ngda-international-boundaries-geoplatform.hub.arcgis.com/api/search/v1/collections/all': { title: 'International Boundaries' },
            '/external/ngda-land-use-land-cover-geoplatform.hub.arcgis.com/api/search/v1/collections/all': { title: 'Land Use - Land Cover' },
            '/external/ngda-portfolio-community-geoplatform.hub.arcgis.com/api/search/v1/collections/all': { title: 'NGDA Portfolio' },
            '/external/ngda-real-property-geoplatform.hub.arcgis.com/api/search/v1/collections/all': { title: 'Real Property' },
            '/external/ngda-soils-geoplatform.hub.arcgis.com/api/search/v1/collections/all': { title: 'Soils' },
            '/external/ngda-transportation-geoplatform.hub.arcgis.com/api/search/v1/collections/all': { title: 'Transportation' },
            '/external/ngda-utilities-geoplatform.hub.arcgis.com/api/search/v1/collections/all': { title: 'Utilities' },
            '/external/ngda-water-inland-geoplatform.hub.arcgis.com/api/search/v1/collections/all': { title: 'Water - Inland' },
            '/external/ngda-water-oceans-and-coasts-geoplatform.hub.arcgis.com/api/search/v1/collections/all': { title: 'Water - Oceans and Coasts' },
            '/external/esri-disasterresponse.hub.arcgis.com/api/search/v1/collections/all': { title: 'Esri Disaster Response' },
            '/external/resilience-fema.hub.arcgis.com/api/search/v1/collections/all': { title: 'FEMA Resilience' },
            '/external/data-napsg.opendata.arcgis.com/api/search/v1/collections/all': { title: 'NAPSG Foundation' },
            '/external/geodata.bts.gov/api/search/v1/collections/all': { title: 'DOT | National Transportation Database' },
            '/external/geospatial-usace.opendata.arcgis.com/api/search/v1/collections/all': {
                title: 'DOD | USACE | ArcGIS Hub',
                description: "The U.S. Army Corps of Engineers Geospatial Open Data provides shared and trusted USACE geospatial data, services and applications for use by our partner agencies and the public.",
            },
            '/external/oceans-esrioceans.hub.arcgis.com/api/search/v1/collections/all': { title: 'Esri Oceans' },
            '/external/data-sagis.opendata.arcgis.com/api/search/v1/collections/all': { title: 'SAGIS' },
            '/external/epa.hub.arcgis.com/api/search/v1/collections/all': {
                title: 'EPA | ArcGIS Hub',
                description: "EPA's official ArcGIS Hub providing access to environmental geospatial datasets, maps, and data services for public discovery and use."
            },
            '/external/disasters-geoplatform.hub.arcgis.com/api/search/v1/collections/all': {
                title: 'DOI | FGDC | GeoPlatform Disasters Hub',
                description: 'Whole community geospatial data, tools, and resources for disaster response and resiliency.'
            },
            '/external/resilience-geoplatform.hub.arcgis.com/api/search/v1/collections/all': {
                title: 'DOI | FGDC | GeoPlatform Resilience Hub',
                description: "Here you can find data related to broad environmental change that can help inform and prepare America's communities, businesses, and citizens."
            },
            '/external/disasters-nasa.hub.arcgis.com/api/search/v1/collections/all': {
                title: 'NASA | Disasters Hub',
                description: 'NASA ArcGIS Online'
            },
            '/external/astrogeology-usgs.hub.arcgis.com/api/search/v1/collections/all': { title: 'DOI | USGS | Astrogeology Hub' },
            '/external/data-usfs.hub.arcgis.com/api/search/v1/collections/all': { title: 'USDA | USFS | Geospatial Data Discovery' },
            '/external/gisforagriculture-usdaocio.hub.arcgis.com/api/search/v1/collections/all': { title: 'USDA | OCIO | GIS for Agriculture' },
            '/external/naip-usdaonline.hub.arcgis.com/api/search/v1/collections/all': { title: 'USDA | FSA | National Agriculture Imagery Program' },
            '/external/usda-fasgis.hub.arcgis.com/api/search/v1/collections/all': { title: 'USDA | FAS | GIS Hub' },
            '/external/usda-snap-retailers-usda-fns.hub.arcgis.com/api/search/v1/collections/all': { title: 'USDA | FNS | SNAP Retailers' },
            '/external/nps-fuels-treatments-nifc.hub.arcgis.com/api/search/v1/collections/all': { title: 'DOI | NPS | Fuels Treatments' },
            '/external/wildfireapps-nifc.hub.arcgis.com/api/search/v1/collections/all': { title: 'DOI | NIFC | Wildfire Apps' },
            '/external/federal-lands-recreation-enhancement-act-hub-usfs.hub.arcgis.com/api/search/v1/collections/all': { title: 'USDA | USFS | Federal Lands Recreation Enhancement Act' },
            '/external/gis-fema.hub.arcgis.com/api/search/v1/collections/all': {
                title: 'DHS | FEMA | Geospatial Resource Center',
                description: 'FEMA Geospatial Resource Center data for disaster response: hazard data (fire perimeters, flood extents, tornado tracks), building footprints, remote sensing (satellite, aerial and UAS imagery), and analytics for disaster risk, vulnerability and resilience.'
            },
            '/external/hepgis-usdot.hub.arcgis.com/api/search/v1/collections/all': { title: 'DOT | FHWA | HEPGIS' },
            '/external/gbp-blm-egis.hub.arcgis.com/api/search/v1/collections/all': { title: 'DOI | BLM | Geospatial Business Platform' },
            '/external/public-data-hub-dhhs.hub.arcgis.com/api/search/v1/collections/all': { title: 'HHS | Protect Public Data Hub' },
            '/external/usgs.hub.arcgis.com/api/search/v1/collections/all': { title: 'USGS ArcGIS Hub' },
            '/external/gis-usflibrary.hub.arcgis.com/api/search/v1/collections/all': { title: 'University of South Florida' },
            '/external/mapsgislib-pennstate.hub.arcgis.com/api/search/v1/collections/all': { title: 'Penn State University' },
            '/external/nasa.hub.arcgis.com/api/search/v1/collections/all': { title: 'NASA ArcGIS Hub' },
            '/external/noaa.hub.arcgis.com/api/search/v1/collections/all': {
                title: 'DOC | NOAA | GeoPlatform Hub',
                description: 'NOAA ArcGIS Online'
            },
            '/external/uscensus.hub.arcgis.com/api/search/v1/collections/all': {
                title: 'DOC | Census ArcGIS Hub',
                description: 'The ArcGIS Hub Census dataset contains official U.S. Census Bureau Census Block boundaries and associated demographic/housing statistics'
            },
            '/external/usgs-lidar-stac.s3-us-west-2.amazonaws.com/ept/catalog.json': { title: 'DOI | USGS | 3DEP LiDAR Point Clouds' },
            '/external/api.water.usgs.gov/gdp/pygeoapi/stac/stac-collection': { title: 'DOI | USGS | Water Mission Area' },
            '/external/stac.dataspace.copernicus.eu/v1': { title: 'Copernicus Data Space Ecosystem (CDSE)' },
            '/external/stac.dataspace.copernicus.eu/v1/collections/sentinel-2-l1c': { title: 'Copernicus | Sentinel-2 Level-1C' },
            '/external/stac.dataspace.copernicus.eu/v1/collections/sentinel-2-l2a': { title: 'Copernicus | Sentinel-2 Level-2A' },
            '/external/earth-search.aws.element84.com/v1/collections/sentinel-2-l2a': { title: 'Earth Search | Sentinel-2 Level-2A (COG)' },
            '/external/asc-stacbrowser.s3.us-west-2.amazonaws.com/catalog.json': { title: 'DOI | USGS | Astrogeology Analysis Ready Data' },
            '/external/stac.astrogeology.usgs.gov/api': { title: 'DOI | USGS | Astrogeology STAC API' },
            '/external/noaa-nos-coastal-lidar-pds.s3.amazonaws.com/entwine/stac/catalog.json': { title: 'DOC | NOAA | Digital Coast LiDAR (EPT)' },
            '/external/cmr.earthdata.nasa.gov/stac': { title: 'NASA | CMR-STAC API' },
            '/external/cmr.earthdata.nasa.gov/cloudstac': { title: 'NASA | CMR-CLOUDSTAC API' },
            '/external/nasa-iserv.s3-us-west-2.amazonaws.com/catalog/catalog.json': { title: 'NASA | ISS SERVIR Environmental Research and Visualization System' }
        };

        return (stac, state) => {
            const path = stac.getBrowserPath();
            const metadata = stacMetadata[path];
            if (metadata) {
                Object.assign(stac, metadata);
            }
            return stac;
        };
    })()
};
